"use strict";

module.exports = require("./is-implemented")()
	? String.prototype.contains
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/string/#/contains/index.js
// module id = 719
// module chunks = 0